const STORAGE_KEY = 'home_tab_seen';

type TabName = 'All' | 'Tasks' | 'Pending' | 'Orders' | 'Previous';

type StoredData = Record<TabName, string[]>;

const getStoredData = (): StoredData => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {} as StoredData;
    const parsed = JSON.parse(raw) as Partial<StoredData>;
    return parsed as StoredData;
  } catch {
    return {} as StoredData;
  }
};

export const getTabSeenIds = (tab: TabName): Set<string> => {
  const data = getStoredData();
  const ids = data[tab];
  return new Set(Array.isArray(ids) ? ids : []);
};

export const setTabSeenIds = (tab: TabName, ids: string[]): void => {
  try {
    const data = getStoredData();
    data[tab] = ids;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // Ignore localStorage errors (quota, private mode, etc.)
  }
};

export const getNewCount = (currentIds: string[], tab: TabName): number => {
  const seenIds = getTabSeenIds(tab);
  return currentIds.filter((id) => !seenIds.has(id)).length;
};
